var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { attrs: { type: "card" } },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 14 } },
            [
              _c("d2-ueditor", {
                model: {
                  value: _vm.text,
                  callback: function($$v) {
                    _vm.text = $$v
                  },
                  expression: "text"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 10 } },
            [
              _vm.text
                ? _c(
                    "el-card",
                    {
                      staticStyle: { border: "1px solid #d4d4d4" },
                      attrs: { shadow: "never" }
                    },
                    [
                      _c("template", { slot: "header" }, [_vm._v("Result")]),
                      _c("div", {
                        staticStyle: { margin: "-20px 0px" },
                        domProps: { innerHTML: _vm._s(_vm.text) }
                      })
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.text += _vm.text
                }
              }
            },
            [
              _c("d2-icon", { attrs: { name: "copy" } }),
              _vm._v(" 当前内容 x2 ")
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { type: "danger" },
              on: {
                click: function($event) {
                  _vm.text = ""
                }
              }
            },
            [_c("d2-icon", { attrs: { name: "trash-o" } }), _vm._v(" 清空 ")],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }